import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-manage-office-details',
  templateUrl: './manage-office-details.component.html',
  styleUrls: ['./manage-office-details.component.css']
})
export class ManageOfficeDetailsComponent implements OnInit {

  @Input() activeSection: string;
  officeName = '';
  errorOfficeName = false;
  formofficeNameError = '';

  constructor() {  }

  ngOnInit() {

  }

  resetAllFields(){
    this.officeName = '';
    this.errorOfficeName = false;
    this.formofficeNameError = '';
  }

  saveOfficeName(){

      this.errorOfficeName = false;

      if(this.officeName){
        this.formofficeNameError = '';
      }else{
        this.formofficeNameError = 'Please Enter Office Name';
        this.errorOfficeName = true;
      }

      if(!this.errorOfficeName){

        // this.route  = 'validate-email';
        // const token = localStorage.getItem('userToken');
        // let data = {'email':this.userDetails['email']};
        //
        // this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
        //
        //   if(response.status == 204) {
        //     localStorage.removeItem('userToken');
        //     localStorage.removeItem('userData');
        //     this.router.navigate(['login']);
        //   }
        //   if(response.status == 200){
        //     if(response.data.length){
        //       this.formErrorEmail = 'Email id already exist';
        //       this.error = true;
        //     }else{
        //       this.formErrorEmail = '';
        //       this.addOfficer();
        //     }
        //   }
        // });
      }


  }

}
